import { TGetState } from '@apia/dom-store';
import { useCallback } from 'react';
import { TListboxState } from './common';
import { findScrollContainer } from '@apia/util';

export function useListboxAutofocus(
  storeId: string,
  getState: TGetState<TListboxState>,
) {
  return {
    onClick: useCallback(() => {
      if (
        document.activeElement !==
        document.querySelector(`#${storeId} .listbox__list`)
      ) {
        const el = document.querySelector<HTMLElement>(
          `#${storeId} .listbox__list`,
        );
        el?.focus({ preventScroll: true });
        el?.scrollIntoView({
          behavior: 'instant' as unknown as 'instant',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    }, [storeId]),
    onFocus: useCallback(() => {
      const focusedRowId = getState().focusedRow + 1;
      const focusedRow = document.querySelector<HTMLElement>(
        `#${storeId} .listbox__list .listbox__row:nth-child(${focusedRowId})`,
      );

      if (focusedRow) {
        const scrollContainer = findScrollContainer(focusedRow);

        if (scrollContainer && scrollContainer.classList.contains('listbox')) {
          scrollContainer.scrollIntoView({
            behavior: 'auto',
            block: 'nearest',
            inline: 'nearest',
          });
          const elRect = focusedRow.getBoundingClientRect();
          const contRect = scrollContainer.getBoundingClientRect();

          if (elRect.top - contRect.top < elRect.height)
            scrollContainer.scrollTop -= elRect.height;
        }

        focusedRow.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    }, [getState, storeId]),
  };
}
